/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ result: NonNullable<unknown> }} Jobs_Toast_FailedInputs */

const cs_jobs_toast_failed = /** @type {(inputs: Jobs_Toast_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selhalo: ${i?.result}`)
};

const en_jobs_toast_failed = /** @type {(inputs: Jobs_Toast_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed: ${i?.result}`)
};

/**
* | output |
* | --- |
* | "Failed: {result}" |
*
* @param {Jobs_Toast_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_toast_failed = /** @type {((inputs: Jobs_Toast_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Toast_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_toast_failed(inputs)
	return cs_jobs_toast_failed(inputs)
});